import { render, staticRenderFns } from "./SouvenirProductsPage.vue?vue&type=template&id=3a35c192&scoped=true&"
import script from "./SouvenirProductsPage.vue?vue&type=script&lang=js&"
export * from "./SouvenirProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./SouvenirProductsPage.vue?vue&type=style&index=0&id=3a35c192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35c192",
  null
  
)

export default component.exports